const url = {
  // 
  // 滤镜 get
  // globalColor: 'https://www.zlo.com.cn:8083/system/config/customerConfigKey/sys_global_color', //线上
  // globalColor: 'http://192.168.1.10:9002/system/config/customerConfigKey/sys_global_color', // 本地
  globalColor: '/system/config/customerConfigKey/sys_global_color',

  // 登录
  // 获取验证码 post
  selectPhoneVcodePC: '/bx/sc/teacher/selectPhoneVcodePC', // {"phone":"15018042206"}
  // 密码登录 post
  selectTeacherPwdLoginPC: '/bx/sc/teacher/selectTeacherPwdLoginPC', //{"phone":"15018042206","password":"123456"}
  // 获取公钥 post
  getEncryp: '/bx/sc/encryp/getEncryp',
  // 学生登录 post
  studentLoginPC: '/bx/sc/student/studentLoginPC',
  // 验证码登录 post
  selectTeacherLoginPC: '/bx/sc/teacher/selectTeacherLoginPC', // {"phone":"AatPd2NOIzL+m8fbabJS3w==","vcode":"111111"}
  // 退出登录 post
  exitLogin: '/bx/sc/teacher/exitLogin',
  // 展示教师个人信息 post
  selectTeacherInformationPC: '/bx/sc/teacher/selectTeacherInformationPC', // {"id": 1}
  // 修改教师个人信息 post
  updateTeacherInformationPC: '/bx/sc/teacher/updateTeacherInformationPC', // {"id": 1,"teacherNumber": "HS1001","teacherName": "李小松","entryDate": "2019-08-31","resume": "测试中测试中",}
  // 教师登陆个人信息查询年级和班级 post
  selectSchoolAndGradeAndClassListPC: '/bx/sc/grade/selectSchoolAndGradeAndClassListPC', // {"schoolId": 1}
  // 查看教师权限（身份） get
  getRolelist: '/bx/sc/role/rolelist',
  // 教师登陆修改个人信息 post
  updateTeacherLoginInformationPC: '/bx/sc/teacher/updateTeacherPersonal', // {"invite_code": "bAalnCLfEB","id": 1,"teacherNumber": "HS1001","teacherName": "李小松","entryDate": "2021-08-31","resume": "测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试"}
  // 教师修改密码 post
  updateTeacherPwdPC: '/bx/sc/teacher/updateTeacherPassword', // {"id":2,"oldPwd": "",f/bx/sc/teacher/updateTeacherLoginInformationPC"newPwd": ""}
  // 根据token获取用户信息 get
  getTeacherByToken: '/bx/sc/teacher/getTeacherByToken', // {"token": ''}
  // 修改教师头像 post fomData格式
  updateTeacherHeadPortraitPC: '/bx/sc/teacher/updateTeacherHeadPortraitPC',
  // 获取用户绑定菜单 get 
  selectMenuByTeacherId: '/bx/sc/menu/selectMenuByTeacherId',
  // 获取个人绑定年级班级信息 get
  getTeacherBindGradeClass: '/bx/sc/grade/getTeacherBindGradeClass',

  // 教师 班级
  // 查看 老师和班级的绑定列表 post 传teacherId获取班级列表  传classId获取教师列表
  selectTeacherListByClassIdPC: '/bx/sc/classteacher/selectTeacherListByClassIdPC', // {"teacherId": 1}
  // 添加  老师和班级绑定 post
  classteacherAdd: '/bx/sc/classteacher/add', // [{"createBy": "1","schoolId": 1,"schoolName": "广州市长兴中学","gradeId": 2,"gradeCode": "cxzxqnj","gradeName": "七年级","classId": 4,"classCode": "7n3b","className": "七年三班","teacherId": 5,"teacherNumber": "HS1003","teacherName": "李倩","isCharge": 0}]
  // 删除 老师和班级绑定 delete /bx/sc/classteacher/18
  // 删除教师与班级绑定关系(班级id/教师id) /bx/sc/classteacher/590/4
  deleteClassteacher: '/bx/sc/classteacher',

  // 教师修改手机号码
  // 修改手机号码前，判断手机是否在数据库,将手机加密对比一下
  selectTeacherPhonePC: '/bx/sc/teacher/selectTeacherPhonePC',
  // 获取修改前手机号码的验证码 post
  selectBeforePhoneVcodePC: '/bx/sc/teacher/selectBeforePhoneVcodePC', // {"phone":"15018042206"}
  // 教师修改手机号码：教师端更改手机号码前传手机号码和验证码做比较 post
  selectTeacherAccountAndSecurityPC: '/bx/sc/teacher/selectTeacherAccountAndSecurityPC', // {"phone":"15018042206","vcode":"111111"}
  // 获取修改后手机号码的验证码
  selectUpdatePhoneVcode: '/bx/sc/teacher/selectUpdatePhoneVcode', // {"phone":"14770016941"}
  // 点击提交换新的手机号码成功之后点击提交进行手机号码加密
  updateTeacherByPhone: '/bx/sc/teacher/updateTeacherByPhone', // {"id":17,"phone":"14770016941","vcode": "111111"}

  // 成绩
  // 查询班级考试信息列表 post
  // selectClassScorePC: '/bx/sc/score/selectClassScorePC',
  // 查询指定考试班级人数 get ?examInfoId=1&classId=1
  selectExamClassPeople: '/bx/sc/examclass/selectExamClassPeople',
  // 修改指定考试班级人数 put
  updateExamClass: '/bx/sc/examclass/updateExamClass',
  // 下载模板
  downloadScoreExcelPC: '/bx/sc/score/downloadScoreExcelPC', // /bx/sc/score/downloadScoreExcelPC/2/7
  // 查询考试信息 get
  getExamInfo: '/bx/sc/exam/info', // /bx/sc/exam/info/1
  // 发布成绩(单科) post
  postScore: '/bx/sc/score', // {"studentName":"落尘","studentNumber":"enenguai","examInfoId":"9","courseId":"1","courseName":"语文","score":60}
  // 查询班级考试信息详情 post
  selectClassExamDetailsPC: '/bx/sc/exam/info/selectClassExamDetailsPC', // {"id":6,"title":"期中考试","subTitle":"第二次期中考","gradeId": 2,"classId": 2}
  // 查询班级某次考试 学生成绩排名 post
  selectClassExamRankByScoreTeacherPC: '/bx/sc/score/selectClassExamRankByScoreTeacherPC', // {"classId": "2","title": "期中考试","subTitle": "第二次期中考","pageNum": "1","pageSize": "15"}
  // 查询学生成绩详情：一个学生的考试信息 post
  studentScoreDescPC: '/bx/sc/score/studentScoreDescPC', // {"studentName": "落尘","studentNumber": "enenguai","title": "月考","subTitle": "12月考试"}
  // 查询学生各科目成绩和分制 post
  selectEveryCourseScoreAndFullScorePC: '/bx/sc/score/selectEveryCourseScoreAndFullScorePC', // {"studentName": "落尘","studentNumber": "enenguai","examInfoId": "1"}
  // 查看考试信息详情 get 有各个科目的分制
  selectExamInfo: '/bx/sc/exam/info/selectExamInfo', // ?id
  // 修改考试信息 post {examInfo: {id,title,subTitle,startTime,endTime,updateBy},fullScore: [{courseId,courseName,fullScore,createBy},{}]}
  updateExamInfo: '/bx/sc/exam/info/updateExamInfo',
  // 创建考试信息 post {examInfo:{schoolId,schoolName,gradeId,gradeCode,gradeName,classId,classCode,className,title,subTitle,startTime,endTime,createBy}fullScore: [{courseId,courseName,fullScore,createBy},{}]}
  createExamInfo: '/bx/sc/exam/info/createExamInfo',
  // 成绩上传 post formData 
  uploadScore: '/bx/sc/score/uploadScore', // /bx/sc/score/uploadScore/考试信息id/班级id
  // 查询年级下班级考试信息列表 管理员 post {schoolId,gradeId,classId,createBy,noCreateBy,title,subTitle,startTime,minScore,maxScore,pageNum,pageSize}
  // createBy和noCreateBy 都传管理员id 分别查看管理员创建的考试和非管理员创建的考试
  selectExamInfoByAdminPC: '/bx/sc/score/selectExamInfoByAdminPC',
  // 批量添加考试信息 管理员同时创建多个考试 post {examInfo: {schoolId,schoolName,gradeId,gradeCode,gradeName,title,subTitle,startTime,endTime,createBy,},classInfo: [{id,classCode,className},{}],fullScore: [{courseId,courseName,fullScore,createBy},{}]}
  batchCreateExamInfo: '/bx/sc/exam/info/batchCreateExamInfo',
  // 查询学生多次考试成绩 get ?studentId=70
  selectExamInfoByStudentId: '/bx/sc/score/selectExamInfoByStudentId',
  // 考试评定
  // 查看学生指定考试科目成绩评定 get ?examInfoId=1&studentId=1
  getEvaluationList: '/bx/sc/evaluation/list',
  // 新增成绩评定 post
  addEvaluation: '/bx/sc/evaluation',
  // 修改成绩评定 put
  editEvaluation: '/bx/sc/evaluation',


  // 管理员 课室 教室
  // 查看教室列表 get 暂时没有关联信标
  getClassroomList: '/bx/sc/classroom/list', // ?schoolId=1&classroomName=1栋105房&pageNum=1&pageSize=10
  // 添加教室信息 post
  addClassroom: '/bx/sc/classroom', //  {"createBy": "1","schoolId": 1,"schoolName": "广州市长兴中学","classroomCode": "105","classroomName": "1栋105房",}
  // 修改教室 post
  putClassroom: '/bx/sc/classroom', // {"id":5,"updateBy": "1","schoolId": 1,"schoolName": "广州市长兴中学","classroomCode": "105","classroomName": "1栋105房二位",}
  // 删除教室 delete
  deleteClassroom: '/bx/sc/classroom/batchDelete', // [10,11,12]

  // 管理员 学校
  // 查看管理员当前学校信息 详细信息 get
  getSchool: "/bx/sc/school", // /bx/sc/school/1
  // 修改学校信息（包括logo和轮播图） post fomData格式
  putSchool: '/bx/sc/school/edit', // {}
  putBanner: '/bx/sc/school/edit/slideshow',
  putSchoolLog: '/bx/sc/school/edit/schoolLog',
  // 修改单个轮播-不传则是删除
  putBannerOneImage: '/bx/sc/school/edit/slideshow/oneImage',
  // 新增单个轮播
  insertSlideshowPC: '/bx/sc/school/edit/slideshow/insertSlideshowPC',
  // 查看学校信息
  getSchoolDetails: '/bx/sc/school/getSchoolDetails',

  // 教师 学生
  // 获取学生列表 get
  selectStudentListPC: '/bx/sc/student/selectStudentListPC', // {"schoolId": 3,"schoolName": "蓝粤测试学校","classId": 1,"className": "真光中学测试班",}
  // 修改学生
  updateStudentPC: '/bx/sc/student/updateStudentPC', // {"id": 128,"studentNumber": "cx128797987","studentName": "小黑小黑哦","address": "1111",}
  // 删除学生信息 post
  deleteStudentPC: '/bx/sc/student/deleteStudentPC', // [136,137]
  // 添加学生信息 
  insertStudentPC: '/bx/sc/student/insertStudentPC', // [{"createBy": "1","studentNumber": "cx73008","gradeId": 2,"gradeName": "七年级","studentName": "小蓝","schoolId": 1,"schoolName": "广州市长兴中学","classId": 4,"className": "七年三班","address": "",}]
  // 下载上传学生信息模板
  getStudentExport: '/bx/sc/student/downloadStudentExcel',
  // 批量上传学生
  uploadStudent: '/bx/sc/student/uploadStudent',
  // 批量修改学生年级班级 post
  updateStudentClass: '/bx/sc/student/updateBathStudent',
  // 学期数据统计 post
  selectStudentSemesterData: '/bx/sc/student/selectStudentSemesterData',
  // 学期数据统计-添加 post
  insertStudentEvaluate: '/bx/sc/studentevaluate/insertStudentEvaluate',
  // 学期数据统计-修改 put
  updateStudentEvaluate: '/bx/sc/studentevaluate/updateStudentEvaluate',
  // 学生评定列表导出(记得带token)
  downloadStudentEvaluate: '/bx/sc/studentevaluate/downloadStudentEvaluate',
  // 学生评定列表上传
  importStudentEvaluate: '/bx/sc/studentevaluate/importStudentEvaluate',

  // 管理员管理教师
  // 管理员查看教师列表 post
  selectTeacherListByAdminPC: '/bx/sc/teacher/selectTeacherListByAdminPC', // {"schoolId":1}
  // 管理员修改教师个人信息 post
  updateTeacherInformationPC: '/bx/sc/teacher/updateTeacherInformationPC', // {"id": 1,"teacherNumber": "HS1001","teacherName": "李小松","entryDate": "2020-08-31","resume": "测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中测试中",}
  // 管理员删除教师信息 post
  deleteTeacher: '/bx/sc/teacher/batchDelete', // [19,20,21]
  // 下载上传教师信息的模板
  downloadTeacherExcel: '/bx/sc/teacher/downloadTeacherExcel',
  // 上传教师信息 表格 post formData
  uploadTeacherExcel: '/bx/sc/teacher/uploadTeacherExcel',
  // 添加单个教师信息 post
  insertTeacherPC: '/bx/sc/teacher/insertTeacherPC', // {"createBy": "157","schoolId": "18","schoolName": "广州市长湴小学","teacherNumber": "wangqwe","teacherName": "李四","phone": "13509909878"}
  // 重置教师密码 post
  resetPassword: '/bx/sc/teacher/resetPassword', // {"id": 74}
  // 教师列表修改-新
  updateTeacherPC: '/bx/sc/teacher/updateTeacherInformationPC',

  // 管理员 科目
  // 查询科目列表 get
  getCourseList: '/bx/sc/course/list', // /bx/sc/course/list?schoolId=3
  // 科目添加 post
  addCourse: '/bx/sc/course', // [{"createBy": 1,"schoolId": 3,"schoolName": "广州市长兴中学","courseName": "语文3"},{}]
  // 删除科目 delete
  deleteCourse: '/bx/sc/course', // /bx/sc/course/1
  // 科目修改 put
  putCourse: '/bx/sc/course', // {"id": 42,"schoolId": 3,"schoolName": "广州市长兴中学","courseName": "语文4"}


  // 管理员 信标
  // 查询信标列表 get
  getBeaconList: '/bx/sc/beacon/list', // /bx/sc/beacon/list?schoolId=1&pageNum=1&pageSize=2
  // 批量添加信标 post
  addBeacon: '/bx/sc/beacon', // [{ "beaconCode": "a1:b1:c1:d1.e1","schoolId": 100,"schoolName": "测试学校"},{}]
  // 批量删除信标 delete
  deleteBeacon: '/bx/sc/beacon', // [7,8]
  // 修改信标 put
  putBeacon: '/bx/sc/beacon', // {"id": 7,"updateBy": 1,"beaconCode": "a9:b1:c1:d1.e1"}

  //班主任 课程编排
  //查询当前班级下科目模块列表 post
  courseModuleList: '/bx/sc/arrange/selectCourseArrangeListByTeacherPC', //{"teacherId": 5,"classId": 100}
  //查询当前班级下的课程表 post
  getCurriculumTable: '/bx/sc/arrange/selectCourseArrangeListByClassId',
  //提交课程表 post
  submitCurriculumTable: '/bx/sc/arrange/addOrModifyCourseArrangePC',
  //批量删除课节 post
  deleteLessons: '/bx/sc/arrange/batchDelete',
  //修改单个课节 put
  updateLessonItem: '/bx/sc/arrange',
  //查询课程时间计划列表 get
  getCourseConstructionList: '/bx/sc/construction/getCourseConstructionList',
  //查询年级课程时间计划详情 get ?id=9
  selectCourseConstructionById: '/bx/sc/construction/selectCourseConstructionById',
  //添加年级课程时间计划 post
  insertCourseConstruction: '/bx/sc/construction/insertCourseConstruction',
  //修改年级课程时间计划 put
  updateCourseConstruction: '/bx/sc/construction/updateCourseConstruction',
  //删除年级课程时间计划 del ?id=9
  deleteCourseConstruction: '/bx/sc/construction/deleteCourseConstruction',
  //自动排课
  //查看年级计划课节数量 get ?gradeId=110
  getCourseConstructionNum: '/bx/sc/construction/getCourseConstructionNum',
  //排课生成 post
  automaticCourseScheduling: '/bx/sc/arrange/automaticCourseScheduling',
  //编辑年级课程时间计划 post
  editBatchCourseConstruction: '/bx/sc/construction/editBatchCourseConstruction',
  //手动调课检查 post
  courseArrangeExchangeCheck: '/bx/sc/arrange/courseArrangeExchangeCheck',
  //保存排课信息 post
  saveCourseArrangeListPC: '/bx/sc/arrange/saveCourseArrangeListPC',
  //查询年级 班级课表信息  post
  selectCourseArrangeList: '/bx/sc/arrange/selectCourseArrangeList',
  //导出课程编排 get ?gradeId=138&classId=698
  exportCourseArrangeByClass: '/bx/sc/arrange/exportCourseArrangeByClass',
  //导出课程编排 get ?gradeId=138
  exportCourseArrangeByGrade: '/bx/sc/arrange/exportCourseArrangeByGrade',
  //导出我的课表
  exportCourseArrangeByMySelf: '/bx/sc/arrange/exportCourseArrangeByMySelf',
  //自动排课保存草稿 post
  saveAutoSchedulingCondition: '/bx/sc/arrange/saveAutoSchedulingCondition',
  //自动排课读取草稿 get ?gradeId=138
  getAutoSchedulingCondition: '/bx/sc/arrange/getAutoSchedulingCondition',
  //删除年级或班级课表 delete
  deleteCourseArrangeList: '/bx/sc/arrange/deleteCourseArrangeList',
  //修改班级指定科目的老师信息 put
  updateCourseArrangeTeacher: '/bx/sc/arrange/updateCourseArrangeTeacher',
  //手动排课课节检查 post
  courseManualModifyCheck: '/bx/sc/arrange/courseManualModifyCheck',

  //管理员 年级班级列表
  //查询当前所有年级班级 get ?schoolId
  getgradeList: '/bx/sc/grade/list',
  //根据ID修改年级信息 put
  editGradeInfoById: '/bx/sc/grade',
  //删除年级 delete
  deleteGradeById: '/bx/sc/grade',
  //批量添加年级 post
  addGrades: '/bx/sc/grade',
  //修改班级 put
  editClassInfo: '/bx/sc/schoolclass',
  //批量添加班级 post
  addClass: '/bx/sc/schoolclass',
  //删除班级 delete
  deleteClass: '/bx/sc/schoolclass',
  //根据班级id获取教师绑定班级列表 get ?classId
  selectTeacherClassList: '/bx/sc/classteacher/selectTeacherClassList',



  // 公告
  // 查询学校公告列表 post classId:管理员(0),教师(当前班级classId); senderId:全部(''),我发布的(用户id)
  getNewsList: '/bx/sc/news/list', // {"schoolId": "1","title": "","senderId": "","classId": 0,"pageNum": "1","pageSize": "2"}
  // 公告详情 get
  getNewsDetail: '/bx/sc/news', // /bx/sc/news/1
  // 添加公告 post formdata格式
  newsAdd: '/bx/sc/news/add',
  // 删除公告 delete
  deleteNews: '/bx/sc/news', // /bx/sc/news/19
  // 修改公告 put formdata格式
  editNews: '/bx/sc/news',
  // 再次推送公告给未读用户 get
  pushRecur: '/bx/sc/news/pushRecur',
  // 获取公告已读列表 get
  getNewsRead: '/bx/sc/newsRead/getNewsRead',
  // 确认已读公告 post
  confirmNewsRead: '/bx/sc/newsRead',

  // 请假
  // 查询学生请假列表 (筛选条件查询) post {classId,status,startTime,leaveType,pageNum,pageSize}
  // status 审核状态(1审批中 2审批通过 3审批拒绝)
  selectStudentLeaveListByFiltrate: '/bx/sc/leaverecord/selectStudentLeaveListByFiltrate',
  // 修改学生请假状态-> 同意/拒绝 post {id,status,updateBy} status:2同意 3拒绝
  updateLeaveRecordStatus: '/bx/sc/leaverecord/updateLeaveRecordStatus',
  // 学生请假类型 post 无参数
  selectLeaveRecordType: '/bx/sc/leaverecord/selectLeaveRecordType',
  // 教师查询学生请假记录详情 post {id}
  selectLeaveRecordDesc: '/bx/sc/leaverecord/selectLeaveRecordDesc',
  // 查看教师是否是当前班级班主任 get ?classId=1
  selectIsExistChargeTeacher: '/bx/sc/classteacher/selectIsExistChargeTeacher',

  // 作业
  // 查询班级已编排的课程id,名称(科目列表) post {classId}
  selectCourseArrangeBySchoolGradeClass: '/bx/sc/arrange/selectCourseArrangeBySchoolGradeClass',
  // 查询班级作业列表：根据其他条件查询 post {classId,publicTime,courseName,title,teacherId,pageNum,pageSize}
  // teacherId为发布者id，为空时查询全部作业
  selectTeacherHomeworkList: '/bx/sc/homework/selectTeacherHomeworkList',
  // 查询老师所带班级科目名称 get ?teacherId&classId
  selectTeacherCourse: '/bx/sc/arrange/selectTeacherCourse',
  // 发布作业 post {schoolId,schoolName,gradeId,gradeCode,gradeName,classId,classCode,className,courseId,courseName,teacherId,teacherName,teacherNumber,title,content,publicTime,endTime,createBy}
  insertHomework: '/bx/sc/homework/insertHomework',
  // 根据作业id获取已提交作业信息 post {homeworkId,studentName,pageNum,pageSize}
  selectSubmitHomeworkList: '/bx/sc/homeworksubmit/selectSubmitHomeworkList',
  // 获取已提交作业详情 get ?id
  selectSubmitHomeworkDesc: '/bx/sc/homeworksubmit/selectSubmitHomeworkDesc',
  // 修改已提交作业 post {id,status,giveMark,comment,updateBy}
  updateSubmitHomework: '/bx/sc/homeworksubmit/updateSubmitHomework',

  // 敏感字
  // 敏感字审批列表 POST {pageNum,pageSize,schoolId,teacherId,teacherName,content,status}
  sensitiveWordReviewList: '/bx/sc/review/sensitiveWordReviewList',
  // 敏感字详情 POST {id}
  sensitivewordReviewId: '/bx/sc/review/sensitivewordReviewId',
  // 敏感字审批 PUT {id,status:1同意 2拒绝}
  updateExamineRecordStatus: '/bx/sc/review/update',
  // 敏感字类型 GET 
  selectSensitiveWordsType: '/bx/sc/words/selectSensitiveWordsType',
  // 敏感字添加 POST {createBy,word,type,schoolId,schoolName}
  insert: '/bx/sc/words/insert',
  // 敏感字查询 POST {pageNum,pageSize,word,type,schoolId}
  queryWords: '/bx/sc/words/',
  // 敏感字删除 DEL {schoolId,dataList:[需要删除的敏感词ID]}
  delWords: '/bx/sc/words/deleteSensitiveWordsPC',
  // 敏感字修改 PUT {id,word,type,updateBy}
  reviseWords: '/bx/sc/words/updateId',

  // 免打扰
  // 查询学生信息 https://www.zlo.com:8000  post {gradeId,classId,studentName}
  getStudentInfo: '/bx/sc/disable/studentDisableInfo',
  // 免打扰添加  https://www.zlo.com:8000 post {qTimeList: [{deviceId,deviceName,morning,afternoon,night,days}]}
  setDisturb: '/bx/sc/disable/insertDisable',
  // 免打扰清空  https://www.zlo.com:8000 post {qTimeList: [{deviceId}]}
  clearDisturb: '/bx/sc/disable/clearDisable',
  // 查询单个设备免打扰信息 get  ?deviceId=73017386340
  findDisable: '/bx/sc/disable/findDisable',

  // 考勤
  // 教师根据时间筛选班级考勤 post {pageNum,pageSize,classId,className,attendanceTime}
  teacherSelectClassAttendanceByTime: '/bx/sc/attendancerecord/teacherSelectClassAttendanceByTime',
  // 教师查看个人考勤 post {pageNum,pageSize,studentId,studentNumber,attendanceTime}
  studentAttendanceRecordByStudentNumber: '/bx/sc/attendancerecord/studentAttendanceRecordByStudentNumber',

  // 学生卡设备管理
  // 查询学校所有设备绑定学生信息 post {deviceId,status,lossStatus,schoolId,gradeId,classId,studentName,pageNum,pageSize}
  selectschoolbinddevice: '/bx/sc/device/selectschoolbinddevice',
  // 修改设备挂失状态 post {lossStatus,deviceId,updateBy}
  updatedevice: '/bx/sc/device/updatedevice',
  // 查询学校所有未绑定设备号 post {schoolId}
  selectnobinddevice: '/bx/sc/device/selectnobinddevice',
  // 修改学生与设备绑定信息 post {studentId,deviceId,updateBy}
  updatestudentdevicebind: '/bx/sc/cardstudent/updatestudentdevicebind',
  // 删除学生与设备绑定关系 delete ?studentId
  deletestudentdevicebind: '/bx/sc/cardstudent/deletestudentdevicebind',

  // 宿舍
  // 获取宿舍列表 get {inFull,blockName,level,dormType,dormName}
  getDormList: '/bx/sc/dorm/list',
  // 获取宿舍详情 get :id
  getDormDetail: '/bx/sc/dorm',
  // 新增宿舍 post {dormName,dormType}
  addDorm: '/bx/sc/dorm',
  // 修改宿舍 put {id,dormName,dormType}
  editDorm: '/bx/sc/dorm',
  // 删除宿舍 del :ids
  delDorm: '/bx/sc/dorm',
  // 学生退宿 del {dormId,studentId}
  studentDormDelBind: '/bx/sc/studentdorm/delBind',
  // 退宿宿舍所有学生 del :ids
  deleteBindByDormIds: '/bx/sc/studentdorm/deleteBindByDormIds',
  // 获取宿舍内的学生信息 get ?dormId=
  selectStudentListByDorm: '/bx/sc/studentdorm/selectStudentListByDorm',
  // 学生入住宿舍 post {dormId,studentId}
  addStudentDorm: '/bx/sc/studentdorm',
  // 查询未入住学生列表 get {schoolId}
  getNotDormStudentList: '/bx/sc/studentdorm/getNotDormStudentList',
  // 数据字典 getf
  getDictType: '/bx/sc/dict/data/type',
  // 获取首页数据 post {schoolId,classId}
  getHomePageData: '/bx/sc/index/homePageData',
  // 查询宿舍 在寝/晚归 的学生信息 post
  selectDormitoryStudent: '/bx/sc/attendancerecord/selectDormitoryStudent',
  // 查询宿舍 未归 的学生信息 post
  selectNotDormitoryStudent: '/bx/sc/attendancerecord/selectNotDormitoryStudent',
  // 一键分配，更换两个宿舍的学生
  changeDormStudent: '/bx/sc/studentdorm/changeDormStudent',

  // 教师分组
  // 查询教师分组 get {crowdName crowdLeader stauts schoolId leaderId createBy}
  getTeacherGroupList: '/bx/sc/crowd/list',
  // 新增教师分组 post {crowdName,leaderId,schoolId}
  addTeacherGroup: '/bx/sc/crowd',
  // 获取指定ID分组 get /:ids
  getTeacherGroup: '/bx/sc/crowd',
  // 修改教师分组 put {id,crowdName,leaderId,schoolId,teacherList}
  editTeacherGroup: '/bx/sc/crowd',
  // 删除分组 del /:ids
  delTeacherGroup: '/bx/sc/crowd',

  // 值日编排
  // 新增教师值日安排 post
  addTeacherDuty: '/bx/sc/duty',
  // 修改教师值日安排 put
  editTeacherDuty: '/bx/sc/duty',
  // 获取教师值日列表 get
  getTeacherDutyList: '/bx/sc/duty/list',
  // 获取教师值日安排明细 get ?dutyId=1
  getTeacherDutyDetail: '/bx/sc/duty',
  // 根据id获取教师值日表格 get ?dutyId=1
  getDutyTableById: '/bx/sc/duty/getTable',
  // 获取默认值日安排表横向列 get
  getParam: '/bx/sc/duty/getParam',
  // 查询值日类型列表 get ?schoolId=25&pageNum=1&pageSize=10
  selectDutyTypeList: '/bx/sc/dutyType/selectDutyTypeList',
  // 修改值日类型 put
  updateDutyType: '/bx/sc/dutyType/updateDutyType',
  // 删除值日类型 del ?id=6
  deleteDutyTypeById: '/bx/sc/dutyType/deleteDutyTypeById',
  // 新增值日类型 post
  insertDutyType: '/bx/sc/dutyType/insertDutyType',
  // 查询值日时间列表 get
  selectDutyList: '/bx/sc/duty/selectDutyList',
  // 删除值日时间 del ?id=4
  deleteDuty: '/bx/sc/duty/deleteDuty',
  // 修改值日时间 put
  updateDuty: '/bx/sc/duty/updateDuty',
  // 新增值日时间 post
  insertDuty: '/bx/sc/duty/insertDuty',
  // 查询值日教师(分配) get
  selectDutyTeacher: '/bx/sc/dutyArrange/selectDutyTeacher',
  // 编辑值日教师(分配) put
  updateDutyTeacher: '/bx/sc/dutyArrange/updateDutyTeacher',
  // 导出值日编排 ?schoolId=25&dutyId=25
  exportDutyTeacher: '/bx/sc/dutyArrange/exportDutyTeacher',

  // 教师调课
  // 教师调课列表 get
  getTeacherApplyForList: '/bx/sc/teacherapplyfor/list',
  // 教师调课明细 get /:id
  getTeacherApplyForDetail: '/bx/sc/teacherapplyfor',
  // 新增调课申请 post
  addTeacherApplyFor: '/bx/sc/teacherapplyfor/add',
  // 修改调课申请 post
  editTeacherApplyFor: '/bx/sc/teacherapplyfor/update',
  // 调课申请审核 post
  reviewTeacherApplyFor: '/bx/sc/teacherapplyfor/review',
  // 撤销调课申请 get ?applyForId=6
  revocationTeacherApplyFor: '/bx/sc/teacherapplyfor/revocation',
  // 教师课程表查询 get
  selectTeacherCourseTable: '/bx/sc/arrange/selectTeacherCourseTable',
  // 调课-查询该班级可以调课的课程 get ?id=1337
  selectCourseArrangeApplyForByClass: '/bx/sc/arrange/selectCourseArrangeApplyForByClass',
  // 教师调课详情（附带申请和审核记录）get ?requestCode=2023071425009
  teacherapplyforDetail: '/bx/sc/teacherapplyfor/get',
  // 查询教师带教班级课程信息和可调课程信息 get ?classId=699
  selectCourseArrangeByTeacherClassId: '/bx/sc/arrange/selectCourseArrangeByTeacherClassId',
  // 查询教师个人排课信息 （我的课表） post
  selectCourseArrangeByTeacher: '/bx/sc/arrange/selectCourseArrangeByTeacher',
  // 查看年级每天最大课节 get?gradeId=138
  getCoursePlanDailyMaxNum: '/bx/sc/construction/getCoursePlanDailyMaxNum',

  // 获奖情况
  // 获取学生获奖情况列表 get
  getMedalList: '/bx/sc/medal/list',
  // 获取学生获奖情况详细信息 get :id
  getMedalDetail: '/bx/sc/medal',
  // 新增学生获奖情况 post
  addMedal: '/bx/sc/medal',
  // 删除学生获奖情况 del :ids
  delMedal: '/bx/sc/medal',

  // 学校场馆管理
  // 查询学校公开场馆列表 get ?schoolId=25
  getPublicvenueList: '/bx/sc/publicvenue/list',
  // 获取学校公开场馆详细信息 get :id
  getPublicvenueDetail: '/bx/sc/publicvenue',
  // 新增学校公开场馆 post
  addPublicvenue: '/bx/sc/publicvenue',
  // 删除学校公开场馆 del /:ids
  delPublicvenue: '/bx/sc/publicvenue',
  // 修改学校公开场馆 put 
  editPublicvenue: '/bx/sc/publicvenue',

  // 场馆预约
  // 查询场馆预约列表 get ?schoolId=25
  getVenueappointmentList: '/bx/sc/venueappointment/list',
  // 获取场馆预约详细信息 get /:id
  // getVenueappointmentDetail: '/bx/sc/venueappointment',
  getVenueappointmentDetail: '/bx/sc/venueappointment/get',
  // 新增场馆预约 post
  addVenueappointment: '/bx/sc/venueappointment',
  // 修改场馆预约 put
  editVenueappointment: '/bx/sc/venueappointment',
  // 审核场馆预约 post
  reviewVenueappointment: '/bx/sc/venueappointment/review',
  // 删除场馆预约 del /:ids
  delVenueappointment: '/bx/sc/venueappointment',
  // 撤回场馆预约 get ?applyForId=2
  // revocationVenueappointment: '/bx/sc/venueappointment/revocation',
  // 获取时间冲突的未审核预约列表 get  ?appointmentId=6
  getTimeConflictVenueappointment: '/bx/sc/venueappointment/getTimeConflict',

  // 实践活动
  // 新增实践活动 post
  addPracticalActivity: '/bx/sc/practicalactivity',
  // 查询实践活动列表 get
  getPracticalActivityList: '/bx/sc/practicalactivity/list',
  // 获取实践活动详细信息 get /:id
  getPracticalActivityDetail: '/bx/sc/practicalactivity',
  // 修改实践活动 put
  editPracticalActivity: '/bx/sc/practicalactivity',
  // 删除实践活动信息 del /:ids
  delPracticalActivity: '/bx/sc/practicalactivity',
  // 查询实践活动记录列表 post
  getPracticeRecordList: '/bx/sc/practicerecord/list',
  // 添加单个学生的实践活动记录 post
  addPracticeRecord: '/bx/sc/practicerecord',
  // 年级班级下载实践活动记录模板 get /:schoolId/:gradeId
  downPracticeRecordExcelPC: '/bx/sc/practicerecord/downPracticeRecordExcelPC',
  // 上传实践活动记录成绩 post /id/:schoolYear/:semester
  uploadGradeUpPracticeRecord: '/bx/sc/practicerecord/uploadPracticeRecord',
  // 修改实践活动记录 put
  editPracticeRecord: '/bx/sc/practicerecord',

  // 审核-通用审核
  schoolReviewRequest: '/bx/sc/schoolReview/reviewRequest',
  // 撤回-通用撤回 get :requestCode
  schoolRequestRevocation: '/bx/sc/schoolRequest/revocation/',
  // 列表-通用 get teacherId,checkCode,status
  schoolRequestList: '/bx/sc/schoolRequest/list',

  // 职务管理
  // 基本信息
  // 查询职务列表 get
  getSchoolJobList: '/bx/sc/schooljob/getSchoolJobList',
  getSchoolEditJobList: '/bx/sc/schooljob/getSchoolJobList',
  // 查询职务详情 get ?jobId=2
  getSchoolJobDetails: '/bx/sc/schooljob/getSchoolJobDetails',
  // 添加职务 post
  sertSchoolJob: '/bx/sc/schooljob/insertSchoolJob',
  // 修改职务 post
  updateSchoolJob: '/bx/sc/schooljob/updateSchoolJob',
  // 删除zhiwu del ?jobId=17
  deleteSchoolJob: '/bx/sc/schooljob/deleteSchoolJob',
  // 添加职务教师绑定 post
  insertTeachersJob: '/bx/sc/teacherjob/insertTeachersJob',
  // 清空职务绑定的教师 delete
  clearJobBindTeacher: '/bx/sc/teacherjob/clearJobBindTeacher',
  // 查询职务绑定教师列表 get ?jobId=11
  getTeachersJobList: '/bx/sc/teacherjob/getTeachersJobList',
  // 查询职务未绑定教师列表 get ?jobId=11
  getTeachersNoJobList: '/bx/sc/teacherjob/getTeachersNoJobList',
  // 新增职务功能菜单绑定 post
  insertJobMenuBath: '/bx/sc/jobmenu/insertJobMenuBath',
  // 删除职务绑定教师 delete
  deleteTeachersJob: '/bx/sc/teacherjob/deleteTeachersJob',
  // 获取职务绑定菜单列表 get :jobId
  getJobMenu: '/bx/sc/jobmenu',

  // 审核类型
  // 查看审核类型列表 get ?schoolId=25&pageNum=1&pageSize=2
  getSchoolCheckList: '/bx/sc/schoolcheck/getSchoolCheckList',
  // 修改审核类型 post 
  updateSchoolCheck: '/bx/sc/schoolcheck/updateSchoolCheck',
  // 查看审核类型与职务绑定 get  ?checkId=1
  getSchoolCheckListBind: '/bx/sc/jobcheck/getSchoolCheckList',
  // 添加审核类型与职务绑定 post 
  insertJobCheckBath: '/bx/sc/jobcheck/insertJobCheckBath',

  // 菜单管理
  // 获取学校功能菜单列表 get
  selectMenuBySchoolId: '/bx/sc/menu/selectMenuBySchoolId',
  // 修改学校菜单 post
  updateSchoolMenu: '/bx/sc/schoolmenu/updateSchoolMenu',
  // 获取个人绑定菜单功能列表 get
  selectMenuByTeacherId: '/bx/sc/menu/selectMenuByTeacherId',

  // 查询数据权限
  // 查询教师班级数据权限列表 get ?teacherId=8
  getClasspowerList: '/bx/sc/classpower/list',
  // 添加、修改教师班级数据权限 post
  insertClassPower: '/bx/sc/classpower/insertClassPower',

  // 成绩分析系统
  // 考试信息
  // 查询学校考试信息列表 get 
  getSchoolExamInfoByTeacher: '/bx/sc/examinfo/selectSchoolExamInfoByTeacher',
  // 查询所有考试主标题 get
  getSchoolExamTitle: '/bx/sc/examinfo/selectSchoolExamTitle',
  // 添加考试信息 post
  insertGradeExamInfo: '/bx/sc/examinfo/insertGradeExamInfo',
  // 修改考试信息 put
  updateGradeExamInfo: '/bx/sc/examinfo/updateGradeExamInfo',
  // 删除考试信息 del ?id=84
  deleteGradeExamInfo: '/bx/sc/examinfo/deleteGradeExamInfo',
  // 查询指定群体考试各科目纬度信息 post
  selectExamDimensionDetails: '/bx/sc/examinfo/selectExamDimensionDetails',
  // 查询指定考试的班级信息 get ?id=93
  selectClassExamInfoRank: '/bx/sc/examinfo/selectClassExamInfoRank',
  // 多次考试名次对比 post
  selectScoreAssignedPosition: '/bx/sc/score/selectScoreAssignedPosition',
  // 年级考试 名次对比 ----> 导出 get ?examInfoIds=112,113&rankings=5,10,15
  scoreAssignedPositionExcel: '/bx/sc/score/scoreAssignedPositionExcelPC',
  // 年级考试纬度信息 ----> 导出 get ?gradeId=141&examInfoId=77
  examDimensionDetailsExcelPC: '/bx/sc/examinfo/examDimensionDetailsExcelPC',

  // 班级对比
  // 获取班级平均分对比 post
  selectScoreClassContrast: '/bx/sc/score/selectScoreClassContrast',
  // 获取单个班级和校外平均分对比 post
  selectScoreClassExtramuralContrast: '/bx/sc/score/selectScoreClassExtramuralContrast',
  // 班级成绩纬度对比 post
  classExamInLatitudeContrast: '/bx/sc/examinfo/classExamInLatitudeContrast',
  // 班级平均分对比 ----> 导出 get ?examInfoId=113&classIds=666, 673, 667, 687
  scoreClassContrastExcelPC: '/bx/sc/score/scoreClassContrastExcelPC',
  // 班级成绩纬度对比  ----> 导出 get ?examInfoId=77&classIds=673,687
  classExamInLatitudeContrastExcelPC: '/bx/sc/examinfo/classExamInLatitudeContrastExcelPC',
  // 多个班级成绩和校外成绩对比结果 ----> 导出 ?classIds=666,667,673&examInfoId=113&outsideSchoolSign=校外测试/期中/测试01050
  scoreClassExtramuralContrastExcelPC: '/bx/sc/score/scoreClassExtramuralContrastExcelPC',

  // 分制
  // 查询年级分制 get ?schoolId=25&gradeId=141
  getCourseFullList: '/bx/sc/coursefull/list',
  // 添加年级分制 post
  updateCourseFull: '/bx/sc/coursefull/updateCourseFull',

  // 分数指标
  // 查询分数指标 get
  getCourseGradeList: "/bx/sc/coursegrade/list",
  // 增加分数指标 多科 post
  addCourseGrade: '/bx/sc/coursegrade',
  // 修改分数指标 put
  editCourseGrade: '/bx/sc/coursegrade',

  // 校外成绩
  // 查询校外成绩 get
  getExternalAchievementPC: '/bx/sc/externalachievement/selectExternalAchievementPC',
  // 新增校外成绩单科 post
  addExternalAchievement: '/bx/sc/externalachievement',
  // 新增校外成绩多科 post
  addExternalAchievementPlenty: '/bx/sc/externalachievement/plenty',
  // 删除校外成绩 del :examInfoId
  delExternalAchievement: '/bx/sc/externalachievement/deleteExternalAchievement',
  // 修改校外成绩 put
  updateExternalAchievement: '/bx/sc/externalachievement/updateExternalAchievement',
  // 年级考试与校外成绩对比 post
  selectScoreGradeExtramuralContrast: '/bx/sc/score/selectScoreGradeExtramuralContrast',
  // 年级考试与校外成绩对比 ----> 导出 get ?examInfoId=113&gradeId=110&outsideSchoolSign=校外测试/期中/测试01050
  scoreGradeExtramuralContrastExcelPC: '/bx/sc/score/scoreGradeExtramuralContrastExcelPC',

  // 成绩录入
  // 成绩录入-单个学生 post
  scorePlentyStudent: '/bx/sc/score/plenty',
  // 成绩模板下载（班级） get /:classId/:examInfoId
  downloadScoreExcelClass: '/bx/sc/score/downloadScoreExcelPC',
  // Excel成绩上传（班级） get file/:examInfoId/:classId
  uploadScoreByClass: '/bx/sc/score/uploadScore',
  // 成绩模板下载（年级） get /:classId/:examInfoId
  downloadScoreExcelGrade: '/bx/sc/score/gradedownloadScoreExcelPC',
  // Excel成绩上传（年级） get file/:examInfoId/:gradeId
  uploadScoreByGrade: '/bx/sc/score/gradeuploadScore',
  // 排名更新  get :examInfoId
  rankingUpdate: "/bx/sc/examrank/ranking",

  // 学生标签
  // 查询学生标签列表 post
  getLabelConditionList: "/bx/sc/labelcondition/list",
  // 修改学生标签名称 put
  editLabelCondition: "/bx/sc/labelcondition",
  // 添加学生标签 post
  addLabelCondition: "/bx/sc/labelcondition/insertLabelConditionBinding",
  // 删除学生标签 delete /:labelId
  delLabelCondition: "/bx/sc/labelcondition",
  // 批量学生标签的绑定 post
  batchAddLabelCondition: "/bx/sc/labelcondition/insertBatchStudentLabel",
  // 查询标签绑定的学生信息 get /:labelId
  selectLabelConditionStudent: "/bx/sc/labelcondition/selectLabelConditionStudent",

  // 查询学生排行 post
  getStudentRanking: "/bx/sc/score/selectStudentRanking",
  // 学生排行信息 ---- > 导出 post ?examInfoId=113&gradeId=138&classId=698&courseIds=[186,187,188]
  studentRankingExcelPC: '/bx/sc/score/studentRankingExcelPC',
  // 指定考试的班级排名信息  ----> 导出 get ?id=113
  classExamInfoRankExcelPC: '/bx/sc/examinfo/classExamInfoRankExcelPC',
  // 单次考试多名学生的平均分排名成绩对比 post
  onceStudentAvgScoreRankContrast: "/bx/sc/score/onceStudentAvgScoreRankContrast",
  // 多次考试多名学生的平均分排名成绩对比 post
  moreStudentAvgScoreRankContrast: "/bx/sc/score/moreStudentAvgScoreRankContrast",
  // 学生成绩对比-选择班级学生-学生列表 get ?examInfoIds=163&examInfoIds=172
  selectStudentComparativeAnalysis: '/bx/sc/score/selectStudentComparativeAnalysis',
  // 查看指定学生考试成绩详情
  getStudentScoreAchievementDetail: '/bx/sc/score/studentScoreAchievement',
  // 修改学生成绩
  updateScoreByStudent: '/bx/sc/score/updateScoreByStudent',
  // 批量删除学生成绩
  deleteStudentScore: '/bx/sc/score/deleteStudentScore',
  // 成绩分析-平均分排行
  selectStudentCourseRanking: '/bx/sc/score/selectStudentCourseRankingByAverageScore',
  // 成绩分析-标准差排行
  selectStudentCourseRankingByStd: '/bx/sc/score/selectStudentCourseRankingByStd',
  // 成绩分析-超均率排行
  selectStudentCourseSuperAverage: '/bx/sc/score/selectStudentCourseSuperAverage',
  // 查询年级排名前几 get ?examInfoId=96&rank=20&pageNum=2&pageSize=10
  selectPreGradeRank: '/bx/sc/score/selectPreGradeRank',
  // 查询各班级排名前几 get ?examInfoId=96&rank=0
  selectPreClassRank: '/bx/sc/score/selectPreClassRank',
  // 查看单科排名前几 get ?examInfoId=96&rank=5
  selectPreCourseRank: '/bx/sc/score/selectPreCourseRank',
  // 各科成绩分析 get ?examInfoId=96
  selectAnalysisEachSubject: '/bx/sc/score/selectAnalysisEachSubject',
  // 总分分数比较 ?id=96
  selectTotalScoreComparison: '/bx/sc/score/selectTotalScoreComparison',
  // 各班成绩统计 ?examInfoId=96
  selectEachClassStatistics: '/bx/sc/score/selectEachClassStatistics',
  // 年级排名前几导出 ?examInfoId=96&rank=2
  exportPreGradeRank: '/bx/sc/score/exportPreGradeRank',
  // 各班级前*  --->  导出 ?examInfoId=96&rank=2
  exportPreClassRank: '/bx/sc/score/exportPreClassRank',
  // 单科前* ---   导出 ?examInfoId=96&rank=2
  exportPreCourseRank: '/bx/sc/score/exportPreCourseRank',
  // 各科成绩分析  --->  导出 ?examInfoId=96
  exportAnalysisEachSubject: '/bx/sc/score/exportAnalysisEachSubject',
  // 总分分数比较   --->  导出 ?examInfoId=96&intervalScore=50&abortScore=200
  exportTotalScoreComparison: '/bx/sc/score/exportTotalScoreComparison',
  // 各班级成绩统计  --->  导出 ?examInfoId=96
  exportEachClassStatistics: '/bx/sc/score/exportEachClassStatistics',
  // 年级班级平均分导出 /:id
  averageScoreExcelDownload: '/bx/sc/score/averageScoreExcelDownload',
  // 年级班级超均率导出 /:id
  superAverageExcelDownload: '/bx/sc/score/superAverageExcelDownload',
  // 年级班级标准差导出 /:id
  standardDeviationExcelDownload: '/bx/sc/score/standardDeviationExcelDownload',

  // 查询学生所有考试成绩(学生考试详情) 以及名次对比 get ?studentId=3
  selectAllExamInfoByStudentId: "/bx/sc/score/selectAllExamInfoByStudentId",
  // 学生所有考试成绩 ----> 导出 get ?studentId=3
  selectAllExamInfoByStudentIdExcelPC: '/bx/sc/score/selectAllExamInfoByStudentIdExcelPC',

  // 学生成绩对比
  // 根据标签来进行多次考试多名学生的平均分排名成绩对比 post
  moreLabelStudentAvgScoreRankContrast: '/bx/sc/score/moreLabelStudentAvgScoreRankContrast',
  // 多次考试多名学生的平均分排名成绩对比 post
  moreStudentAvgScoreRankContrast: '/bx/sc/score/moreStudentAvgScoreRankContrast',
  // 指定年级或标签学生 多次考试对比  ----> 导出 get ?examInfoIds=112,113&studentIds=14,16,40,89
  moreStudentAvgScoreRankContrastExcelPC: '/bx/sc/score/moreStudentAvgScoreRankContrastExcelPC',

  // 选修成绩
  // 查询选修课成绩列表 post
  getElectiveGradeList: '/bx/sc/electivegrade/list',
  // 修改选修课成绩 put
  editElectiveGrade: '/bx/sc/electivegrade',
  // 新增选修课成绩-单个 post
  addElectiveGrade: '/bx/sc/electivegrade',
  // 上传学生选修课成绩-表格形式 post /:schoolYear/:semester
  uploadGradeUpElectiveGrade: '/bx/sc/electivegrade/gradeupElectiveGrade',
  // 班级下载选修课成绩模板 get /:schoolId/:classId
  gradeDownElectiveClassExcelPC: '/bx/sc/electivegrade/gradeDownElectiveClassExcelPC',
  // 年级下载选修课成绩模板 get /:schoolId/:gradeId
  gradeDownElectiveGradeExcelPC: '/bx/sc/electivegrade/gradeDownElectiveGradeExcelPC',

  // 调查统计表
  // 查询 get ?schoolId=25&startTime=2023-02-03&endTime=2024-01-08&gradeId=110&classId=673
  getSurveyFormsList: '/bx/sc/surveyfroms/list',
  // 删除 delete /:id
  delSurveyForms: '/bx/sc/surveyfroms',
  // 添加 post
  addSurveyForms: '/bx/sc/surveyfroms',
  // 详情 get /:id
  selectQuestionnaireFormDetail: '/bx/sc/surveyfroms/selectQuestionnaireFormDetail',
  // 添加统计表结果 post
  insertStatisticalResult: '/bx/sc/surveyfroms/insertStatisticalResult',
  // 查询调查表统计信息 get /:id
  selectSurveyFormsStatistical: '/bx/sc/surveyfroms/selectSurveyFromsStatistical',
  // 查看学生回答详情 get /:formsId/:studentId
  selectStudentSurveyResponse: '/bx/sc/surveyfroms/selectStudentSurveyResponse',
  // 消息再次推送 get /:id
  resendSurveyData: '/bx/sc/surveyfroms/ResendSurveyData',
  // 查询模版列表
  queryTemplateType: '/bx/sc/surveyfroms/queryTemplateType',
  // 模版分类
  queryTemplateTypeCategory: '/bx/sc/surveyfroms/queryTemplateTypeCategory',
  // 二维码生成base64
  generateQrCode: '/bx/sc/surveyfroms/generateQrCode',

  // 学校文具发放系统
  // 学校文具用品列表 get 
  selectSchoolStationeryList: '/bx/sc/schoolstationery/selectSchoolStationeryList',
  // 删除学校文具 delete ?ids=11,12
  deleteSchoolStationery: '/bx/sc/schoolstationery/deleteSchoolStationery',
  // 添加学校文具 post
  insertSchoolStationery: '/bx/sc/schoolstationery/insertSchoolStationery',
  // 修改学校文具 put
  updateSchoolStationery: '/bx/sc/schoolstationery/updateSchoolStationery',

  // 文具申请记录 get
  selectStationeryRecordList: '/bx/sc/stationeryrecord/selectStationeryRecordList',
  // 添加申请记录 post
  insertStationeryRecord: '/bx/sc/stationeryrecord/insertStationeryRecord',
  // 申请详情 get ?id=1
  selectStationeryRecordDetailsById: '/bx/sc/stationeryrecord/selectStationeryRecordDetailsById',
  // 审批申请 put
  auditStationeryRecord: '/bx/sc/stationeryrecord/auditStationeryRecord',
  // 修改申请 put
  updateStationeryRecord: '/bx/sc/stationeryrecord/updateStationeryRecord',
  // 申请统计 get ?itemName=记号&teacherName=员&status=1&startTime=2024-06-17&endTime=2024-06-18&pageNum=1&pageSize=1
  selectStationeryDetailsList: '/bx/sc/stationerydetails/selectStationeryDetailsList',
  // 查詢我的申請記錄 get
  selectStationeryRecordByMySelf: '/bx/sc/stationeryrecord/selectStationeryRecordByMySelf',
  // 撤回申请记录 put
  withdrawStationeryRecord: '/bx/sc/stationeryrecord/withdrawStationeryRecord',

  // 教师评价
  // 标准制定-添加/修改 post
  insetTeacherEvaluation: '/bx/sc/teacherevaluation/inserteacherevaluation',
  // 查询指定类型教评问题列表 get ?schoolId=2&questionType=0
  selectTeacherEvaluation: '/bx/sc/teacherevaluation/selectteacherevaluation',
  // 评定管理-查询指定学生的教师评价列表 get 
  selectTeacherEvaluationRecords: '/bx/sc/teachervaluationrecords/selectteacherevaluationrecords',
  // 评定管理-学生评价教师点击保存 post
  insetTeacherEvaluationRecords: '/bx/sc/teachervaluationrecords/inserteacherevaluationrecords',
  // 统计结果-查询教师统计结果列表 get
  selectAllTeacherRecords: '/bx/sc/teachervaluationrecords/selectAllTeacherRecords',
  // 统计结果-查询单个教师的统计结果 get
  getTeacherRecordsProportion: '/bx/sc/teachervaluationrecords/teacherRecordsProportion',
  // 导出统计结果 
  teacherEvaluationExcelPC: '/bx/sc/teachervaluationrecords/teacherEvaluationExcelPC',

  // 学生导师
  // 查询教师下属导师信息 get
  selectTeacherAllotByTeacher: '/bx/sc/teacherallot/selectTeacherAllotByTeacher',
  // 查询教师下属已绑定的教师信息 get ?teacherId=8
  selectTeacherAllotByTeacherId: '/bx/sc/teacherallot/selectTeacherAllotByTeacherId',
  // 批量添加或修改教师下属教师 post
  editTeacherAllot: '/bx/sc/teacherallot/editTeacherAllot',
  // 查询教师下属学生 get ?teacherId=8
  selectTeacherStudentLinkByTeacher: '/bx/sc/teacherstudentlink/selectTeacherStudentLinkByTeacher',
  // 查询未分配的学生 get
  selectTeacherStudentLinkUndistributed: '/bx/sc/teacherstudentlink/selectTeacherStudentLinkUndistributed',
  // 导师分配学生-添加
  insertTeacherStudentLink: '/bx/sc/teacherstudentlink/insertTeacherStudentLink',
  // 导师分配学生=删除
  deleteTeacherStudentLink: '/bx/sc/teacherstudentlink/deleteTeacherStudentLink',
  // 学生授权给指定教师
  studentDelegationTutor: '/bx/sc/teacherstudentlink/studentDelegationTutor',
  // 撤销学生授权
  studentDelegationRevocationTutor: '/bx/sc/teacherstudentlink/studentDelegationRevocationTutor',

  // 查询家校沟通记录
  selectSchoolHomeInterviewList: '/bx/sc/schoolhomeinterview/selectSchoolHomeInterviewList',
  // 家校沟通详情
  selectSchoolHomeInterviewById: '/bx/sc/schoolhomeinterview/selectSchoolHomeInterviewById',
  // 家校沟通记录-添加
  insertSchoolHomeInterview: '/bx/sc/schoolhomeinterview/insertSchoolHomeInterview',
  // 家校沟通记录-修改
  editSchoolHomeInterview: '/bx/sc/schoolhomeinterview/editSchoolHomeInterview',
  // 家校沟通记录-删除
  deleteSchoolHomeInterview: '/bx/sc/schoolhomeinterview/deleteSchoolHomeInterview',

  // 查询师生互动记录
  selectTalkStudentInfoList: '/bx/sc/talkrecordmain/selectTalkStudentInfoList',
  selectTeacherStudentInteractList: '/bx/sc/talkrecorddetails/selectTalkRecordDetailsList',
  // 师生互动记录-添加
  insertTeacherStudentInteract: '/bx/sc/talkrecorddetails/insertTalkRecordDetailsAll',
  // 师生互动记录-修改
  editTeacherStudentInteract: '/bx/sc/talkrecorddetails/editTalkRecordDetails',
  // 师生互动记录-删除-详情
  deleteTeacherStudentInteract: '/bx/sc/talkrecorddetails/removeTalkRecordDetailsList',
  // 师生互动记录-删除-列表
  deleteTalkStudentInfo: 'bx/sc/talkrecordmain/deleteTalkStudentInfo',
  // 查询学生基本信息
  selectTalkStudentInfoById: '/bx/sc/talkrecordmain/selectTalkStudentInfoById',
  // 师生互动记录-基本信息-添加
  insertTalkStudentInfo: '/bx/sc/talkrecordmain/insertTalkStudentInfo',
  // 师生互动记录-基本信息-修改
  editTalkStudentInfo: '/bx/sc/talkrecordmain/editTalkStudentInfo',

  // 查询学生行为记录
  selectStudentBehaviorList: '/bx/sc/studentbehavior/selectStudentBehaviorList',
  // 学生行为记录-添加
  insertStudentBehavior: '/bx/sc/studentbehavior/insertStudentBehavior',
  // 学生行为记录-修改
  editStudentBehavior: '/bx/sc/studentbehavior/editStudentBehavior',
  // 学生行为记录-删除
  deleteStudentBehavior: '/bx/sc/studentbehavior/deleteStudentBehavior',
  // 查询班主任列表
  getClassTeacherList: '/bx/sc/classteacher/list',
  // 查询学生的导师列表
  selectStudentSupervisor: '/bx/sc/teacherstudentlink/selectStudentSupervisor',

  // 教师下属教师记录统计
  selectTeacherAllotStatistics: '/bx/sc/teacherallot/selectTeacherAllotStatistics',
  // 导出教师下属教师记录统计
  exportTeacherAllotStatistics: '/bx/sc/teacherallot/exportTeacherAllotStatistics',

  // 私聊功能
  // 查询班级家长信息
  selectPatriarchInfoByClassId: '/bx/sc/patriarch/selectPatriarchInfoByClassId',
  // 发送消息
  sendMessage: '/bx/sc/message/send',
  // 刷新websocket项目token
  refreshTokenTeacher: '/bx/sc/teacher/refreshTokenTeacher',
  // 拉取离线消息 ?classId=&studentId=&minId=2
  pullOfflineMessage: '/bx/sc/message/pullOfflineMessage',

  // 家庭成员
  // 查询家庭成员列表
  selectStudentFamilyList: '/bx/sc/studentfamily/selectStudentFamilyList',
  // 添加家庭成员
  insertStudentFamily: '/bx/sc/studentfamily/insertStudentFamily',
  // 修改家庭成员
  updateStudentFamily: '/bx/sc/studentfamily/updateStudentFamily',
  // 删除家庭成员
  deleteStudentFamilyById: '/bx/sc/studentfamily/deleteStudentFamilyById',

  // 学生重大经历
  // 查询
  selectStudentExperience: '/bx/sc/studentExperience/selectStudentExperience',
  // 添加
  insertStudentExperience: '/bx/sc/studentExperience/insertStudentExperience',
  // 修改
  updateStudentExperience: '/bx/sc/studentExperience/updateStudentExperience',

  // 领导评价项目
  // 查询
  selectTutorEvaluationScaleList: '/bx/sc/tutorevaluationscale/selectTutorEvaluationScaleList',
  // 编辑
  editTutorEvaluationScale: '/bx/sc/tutorevaluationscale/editTutorEvaluationScale',
  // 删除
  deleteTutorEvaluationScaleById: '/bx/sc/tutorevaluationscale/deleteTutorEvaluationScaleById',
  // 评价记录
  selectTutorEvaluationDetailsList: '/bx/sc/tutorevaluationdetails/selectTutorEvaluationDetailsList',
  // 编辑评价
  editTutorEvaluationDetails: '/bx/sc/tutorevaluationdetails/editTutorEvaluationDetails',

  // 综合素质评定项目
  // 查询
  selectComprehensiveQualityItem: '/bx/sc/comprehensivequality/selectComprehensiveQualityItem',
  // 添加
  insertComprehensiveQuality: '/bx/sc/comprehensivequality/insertComprehensiveQuality',
  // 删除
  deleteComprehensiveQualityById: '/bx/sc/comprehensivequality/deleteComprehensiveQualityById',
  // 批量删除
  deleteComprehensiveQualityByIds: '/bx/sc/comprehensivequality/deleteComprehensiveQualityByIds',
  // 查询基础信息
  selectComprehensiveQualityDetailsByParam: '/bx/sc/comprehensivequalitydetails/selectComprehensiveQualityDetailsByParam',
  // 添加基础信息
  insertComprehensiveQualityDetails: '/bx/sc/comprehensivequalitydetails/insertComprehensiveQualityDetails',
  // 修改基础信息
  updateComprehensiveQualityDetails: '/bx/sc/comprehensivequalitydetails/updateComprehensiveQualityDetails',
  // 查看综合评定项记录
  selectComprehensiveQualityAssessmentList: '/bx/sc/comprehensivequalityassessment/selectComprehensiveQualityAssessmentList',
  // 编辑综合评定项记录
  editComprehensiveQualityAssessment: '/bx/sc/comprehensivequalityassessment/editComprehensiveQualityAssessment',

  // 学生学习生活评定
  selectStudentLifeList: '/bx/sc/studentlife/selectStudentLifeList',
  // 添加
  insertStudentLife: '/bx/sc/studentlife/insertStudentLife',
  // 修改
  updateStudentLife: '/bx/sc/studentlife/updateStudentLife',
  // 删除
  deleteStudentLifeById: '/bx/sc/studentlife/deleteStudentLifeById',
  // 学生基本信息-新增评定记录
  insertStudentLifeEvaluate: '/bx/sc/studentilfeevaluate/insertStudentLifeEvaluate',
  // 学生基本信息-获取评定记录列表
  selectStudentLifeEvaluateList: '/bx/sc/studentilfeevaluate/selectStudentLifeEvaluateList',

  // 学生基本信息
  getStudentDetailInfo: '/bx/sc/student/selectStudentById',
}

export default url